export const ELECTRON_MASS = 5.4857990907e-4;
